import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import { UserViewModel } from 'stageclip-common';

import { createRequestUserAction } from '../../actions/userActions';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import { getItem } from '../../store/selectors';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../componentBase';

import ChangePassword from './changePassword';

interface ChangeOtherUsersPasswordStateProps extends BaseStateProps {
  user: UserViewModel;
}

interface ChangeOtherUsersPasswordDispatchProps extends BaseDispatchProps {
  loadUser: (c: ChangeOtherUsersPassword) => void;
}

export class ChangeOtherUsersPassword extends ComponentBase<
  RouteComponentProps<any>,
  ChangeOtherUsersPasswordStateProps,
  ChangeOtherUsersPasswordDispatchProps
> {
  protected dataLoaded(props: any) {
    return props.user !== undefined;
  }

  protected async loadData(props: any) {
    await props.loadUser(this);
  }

  protected loggedInRender(): JSX.Element | string {
    return (
      <div>
        <ChangePassword
          userId={this.props.user.id}
          displayText={`Change password for ${this.props.user.firstName} ${this.props.user.lastName}:`}
        />
      </div>
    );
  }
}

function mapStateToProps(
  state: ClippingPlatformState,
  ownProps: RouteComponentProps<any>,
): ChangeOtherUsersPasswordStateProps {
  const { session } = state.appStatus;
  const currentUser = getItem(state.entities.users, session.user);

  return {
    ...baseMapStateToProps(state),
    user: getItem(state.entities.users, ownProps.match.params.userId || currentUser.id),
  };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: RouteComponentProps<any>) {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadUser: (c: ChangeOtherUsersPassword) =>
      dispatch(createRequestUserAction(ownProps.match.params.userId, c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeOtherUsersPassword);
